module.exports = __webpack_public_path__ + "static/ui-classic-2bd2c58b1e8bcd60a3c740a7a71babdc.png";